export default "__VITE_ASSET__Coathi3L__"